import React from 'react';
import { useQuery, useDetail } from "seed/gql";
import { USER } from "seed/gql/queries";
import { Loading } from "seed/helpers";
import View from 'components/tmisc/portal/proposed/Proposed.view';

const PortalProposed = ({ flow }) => {

  const userId = sessionStorage.getItem("id");
  const reqUser = useDetail(USER, userId);

  const reqRevision = useQuery(`{
    flowVersions {
      id
      name
      type
      status
      data
    }
  }`, `(flow.id=${flow.id} AND type<>RELEASE)`, { orderBy: "-created_at", limit: 1 });

  if (reqRevision.loading)
    return <Loading />;

  const lastRevision = reqRevision.data?.flowVersions?.[0] || {};
  const revisionData = lastRevision.data || {};
  const revisionId = lastRevision.id;
  const revisionStatus = lastRevision.status;
  const revisionContent = revisionData.project_proposal || {};
  const revisionDetails = revisionData.project_details || {};
  const revisionType = lastRevision.type;
  const hasRevision = !!revisionId;

  const user = reqUser.data?.user;
  const currentAuthor = `${user?.firstName} ${user?.lastName || ""}`;

  return (
    <View
      flow={flow}
      hasRevision={hasRevision}
      revisionId={revisionId}
      revisionType={revisionType}
      revisionStatus={revisionStatus}
      revisionContent={revisionContent}
      revisionDetails={revisionDetails}
      currentAuthor={currentAuthor}
      onUpdate={reqRevision.refetch}
    />
  );

}

export default PortalProposed;